/** Rubros: banda con 4 fotos de PYMEs chilenas reales generadas con Nano Banana.
 *  Refuerza confianza mostrando el público objetivo. */
export default function RubrosBand() {
  const items = [
    { src: "/segmentos/pyme-cafe.jpg", label: "Cafeterías", alt: "Dueño de cafetería chilena" },
    { src: "/segmentos/pyme-almacen.jpg", label: "Almacenes de barrio", alt: "Almacenera de barrio chileno" },
    { src: "/segmentos/pyme-dentista.jpg", label: "Consultas de salud", alt: "Dentista en consulta moderna" },
    { src: "/segmentos/pyme-contador.jpg", label: "Servicios profesionales", alt: "Contador en oficina" },
  ];

  return (
    <section
      data-testid="rubros-band"
      className="w-full bg-white border-y border-slate-100 px-6 py-14 sm:py-20"
    >
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-10">
          <div className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.22em] text-blue-700 uppercase mb-3">
            <span className="inline-block w-6 h-px bg-blue-400/60" />
            Hecho para PYMEs chilenas
          </div>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
            Un cumplimiento pensado para tu rubro.
          </h2>
          <p className="mt-3 text-slate-600 text-base">
            Cafeterías, almacenes, clínicas, servicios profesionales. Cada uno con su propia realidad de datos.
            El escáner adapta el reporte y los documentos a lo que hace tu negocio.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {items.map((r) => (
            <div key={r.label} data-testid={`rubro-${r.label.toLowerCase().replace(/\s+/g, "-")}`} className="group relative overflow-hidden rounded-2xl aspect-[4/5] bg-slate-100">
              <img
                src={r.src}
                alt={r.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="text-white font-semibold text-sm sm:text-base leading-tight">{r.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
